import React from 'react';
import { Chip } from '@mui/material';
import type { MovementType } from '../../types/venue';

interface Props {
  type: MovementType;
  size?: 'small' | 'medium';
}

const CONFIG: Record<MovementType, { label: string; color: string; bg: string }> = {
  RECEIVE:            { label: 'Receive',          color: '#1a7f37', bg: '#dafbe1' },
  DEPLETE:            { label: 'Deplete',           color: '#6e40c9', bg: '#ede9fe' },
  TRANSFER_IN:        { label: 'Transfer In',       color: '#0969da', bg: '#dbeafe' },
  TRANSFER_OUT:       { label: 'Transfer Out',      color: '#9a6700', bg: '#fef9c3' },
  COUNT_VARIANCE:     { label: 'Count Variance',    color: '#cf222e', bg: '#ffebe9' },
  MANUAL_ADJUSTMENT:  { label: 'Adjustment',        color: '#6e7781', bg: '#f6f8fa' },
  WASTE:              { label: 'Waste',             color: '#bc4c00', bg: '#fff1e5' },
  RETURN_TO_SUPPLIER: { label: 'Return',            color: '#8250df', bg: '#fbefff' },
  SALE:               { label: 'Sale',              color: '#0969da', bg: '#dbeafe' },
  SALE_REVERSAL:      { label: 'Sale Reversal',     color: '#9a6700', bg: '#fef9c3' },
};

const MovementTypeBadge: React.FC<Props> = ({ type, size = 'small' }) => {
  const cfg = CONFIG[type] ?? { label: type, color: '#6e7781', bg: '#f6f8fa' };
  return (
    <Chip
      label={cfg.label}
      size={size}
      sx={{
        fontWeight: 600,
        fontSize: size === 'small' ? '0.7rem' : '0.75rem',
        color: cfg.color,
        backgroundColor: cfg.bg,
        border: 'none',
        height: size === 'small' ? 22 : 28,
      }}
    />
  );
};

export default MovementTypeBadge;
